/*                                                  */
/*                                                             */

import type { CarouselPattern } from "./carousel/src";
import type { EventAcceptWrapper } from "./common/src/pattern/head";
import { logLegacyWarnings } from "./legacy_warnings";

/*     */
import type { Pali } from "./head";

export * from "./carousel/src/index";
export type {
  DropDownEvents,
  Pali,
  Presets,
  Sheet,
  SheetCloseTypes,
  SheetEvents,
  Slider,
  SliderElement,
  SliderEvents,
  SnackbarEvents,
  SnackbarSettings,
  TextExpanderEvents,
  TooltipEvents,
} from "./head";

export interface GlobalPattern {
  carousel: EventAcceptWrapper<CarouselPattern>;
  /*                               */
}

declare global {
  interface OttoGlobal {
    /**
 *
 *
 *
 *
 *
 */
    pali: Pali;
  }

  interface Window {
    o_pattern: GlobalPattern;
  }
}

try {
  window.o_global.events().once("assets.events.allJavascriptLoaded", () => {
    logLegacyWarnings();
  });
} catch (e) {
  /*       */
}
